import { useState, useEffect } from 'react';

const WHATSAPP_NUM = '971547172715';
const WELCOME_MSG = 'مرحباً! 👋 أنا هنا لمساعدتك. هل لديك استفسار عن منتج أو طلب؟';
const WHATSAPP_PRESET = 'مرحباً، أود الاستفسار عن منتجاتكم 😊';

export default function WhatsAppFloat() {
  const [bubbleVisible, setBubbleVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [pulse, setPulse] = useState(true);

  // Show bubble after 3 seconds automatically
  useEffect(() => {
    const alreadyDismissed = sessionStorage.getItem('wa_bubble_dismissed');
    if (alreadyDismissed) return;

    const timer = setTimeout(() => {
      setBubbleVisible(true);
    }, 3000);

    // Stop pulse after 6 seconds
    const pulseTimer = setTimeout(() => setPulse(false), 6000);

    return () => {
      clearTimeout(timer);
      clearTimeout(pulseTimer);
    };
  }, []);

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setBubbleVisible(false);
    setDismissed(true);
    sessionStorage.setItem('wa_bubble_dismissed', '1');
  };

  const handleToggleBubble = () => {
    if (dismissed) {
      setBubbleVisible(prev => !prev);
    } else {
      setBubbleVisible(prev => !prev);
    }
  };

  const waLink = `https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent(WHATSAPP_PRESET)}`;

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col items-start gap-3" dir="rtl">

      {/* Welcome Bubble */}
      <div
        className={`transition-all duration-500 ${
          bubbleVisible
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="relative bg-white rounded-2xl rounded-bl-sm px-4 py-3.5 max-w-[260px] border border-gray-100"
          style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}
        >
          {/* Close button */}
          <button
            onClick={handleDismiss}
            className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-full cursor-pointer transition-colors"
            aria-label="إغلاق"
          >
            <i className="ri-close-line text-gray-600 text-xs" />
          </button>

          {/* Agent header */}
          <div className="flex items-center gap-2.5 mb-2.5 pb-2.5 border-b border-gray-100">
            <div className="relative flex-shrink-0">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#25D366]">
                <i className="ri-customer-service-2-line text-white text-base" />
              </div>
              {/* Online dot */}
              <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-400 rounded-full border-2 border-white" />
            </div>
            <div>
              <p className="text-gray-900 font-black text-xs leading-none mb-0.5">فريق الدعم</p>
              <p className="text-green-500 text-[10px] font-semibold">متاح الآن</p>
            </div>
          </div>

          {/* Message */}
          <p className="text-gray-700 text-xs leading-relaxed mb-3">{WELCOME_MSG}</p>

          {/* CTA */}
          <a
            href={waLink}
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white text-xs font-bold py-2.5 rounded-xl cursor-pointer transition-colors whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-sm" />
            </div>
            ابدأ المحادثة
          </a>

          {/* Bubble tail */}
          <div className="absolute -bottom-2 left-5 w-4 h-4 bg-white border-b border-l border-gray-100 rotate-45" />
        </div>
      </div>

      {/* Main FAB Button */}
      <div className="relative">
        {/* Pulse rings */}
        {pulse && (
          <>
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 animation-delay-300" />
          </>
        )}

        <button
          onClick={handleToggleBubble}
          className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] rounded-full cursor-pointer transition-all duration-300 hover:scale-110"
          aria-label="تواصل عبر واتساب"
        >
          <div className="w-7 h-7 flex items-center justify-center">
            <i className={`text-white text-2xl transition-all duration-300 ${bubbleVisible ? 'ri-close-line' : 'ri-whatsapp-line'}`} />
          </div>
        </button>

        {/* Unread badge */}
        {!bubbleVisible && !dismissed && (
          <span className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center bg-red-500 text-white text-[10px] font-black rounded-full animate-bounce">
            1
          </span>
        )}
      </div>
    </div>
  );
}
